// extracted by mini-css-extract-plugin
export default {"image_modal":"imagemodal_image_modal__IV7oV","close":"imagemodal_close__XjVCl","modal_content":"imagemodal_modal_content__ODU5V","zoom":"imagemodal_zoom__75XNF"};